const exerciseLinkMap: Record<TExercise, string> = {
  wordCards: 'wordcards',
  wordCardsReverse: 'translate',
};

export const getFavIconUrl = () => `/favicon.svg`;

export const getDashboardUrl = () => '/dashboard';

export const getLoginUrl = () => '/login';

export const getDeckExerciseUrl = (
  deckUid: string,
  exercise: TExercise,
  wordUid?: string
) =>
  `/${exerciseLinkMap[exercise]}/${deckUid}` + (wordUid ? `/${wordUid}` : '');

export const getDeckGraphUrl = (deckUid: string) => `/graph/${deckUid}`;

export const getNumbersUrl = (lang: TLang | ':lang') => `/numbers/${lang}`;

export const getExerciseUrl = (deckUid: string, exercise: TExercise) =>
  `/${exerciseLinkMap[exercise]}/${deckUid}`;

export const getDeckUrl = (deckUid: string): string => `/list/${deckUid}`;

export const getDecksListUrl = () => `/decks`;

export const getTestUrl = (
  testUid: string,
  mode: 'pending' | 'all' = 'all',
  questionUid = ''
) =>
  `/tests/${testUid}?mode=${mode}${
    questionUid ? `&question=${questionUid}` : ''
  }`;

export const getTestQuestionsUrl = (testUid: string) => `/questions/${testUid}`;

export const getAdminUrl = (subPage?: 'users') => `/admin/${subPage ?? ''}`;
